import React, {useState, useRef} from 'react';
import "../Styles/fontawesome-free-5.15.3-web/css/all.css";
import "../Styles/SymbolMatching.css";
import SymbolMatchingPlayerTable from "./SymbolMatchingPlayerTable";
import ButtonContainer from "./ButtonContainer";
import COLORS from "../Colors.js";
import ReactTooltip from "react-tooltip";
import * as api from '../Scripts/Api';
import {SYMBOL_TASK} from '../Utilities/Constants';
import {useContext, createContext, useEffect } from 'react';
//import CorrectElem from "./Correct";
import Correct from './Correct';


// props:
// demo: Boolean -- is this in demo mode
// onCompletion: callback that allows us to show the popup. Takes in nothing
// started: bool that indicates whether the game should start or not
export default function SymbolMatchingGame(props) {

    const symbolValues = [1,2,3,4,5,6,7,8,9]

    const symbols = [
        'fas fa-circle',
        'fas fa-share-alt',
        'fas fa-snowflake',
        'fas fa-square',
        'fas fa-star',
        'fas fa-lightbulb',
        'fas fa-lock',
        'fas fa-play',
        'fas fa-hourglass'
      ]

    const tutorialTextsEnglish = [
        "Look at the boxes across the top of the screen.",
        "On the top in each box, there is a symbol.",
        "On the bottom part of each box there is a number 1 through 9.",
        "Each symbol is paired with a number. For example, the star is paired with the number 5.",
        "These boxes have numbers on the bottom, but the top box is empty.",
        "You will click the buttons below to select the correct symbol to pair with the number below the highlighted box.",
        "Let's practice with the numbers shown on the screen.",
    ]

    const tutorialTextsEspanol = [
        "Mire los cuadros en la parte superior de la pantalla.",
        "En la parte superior de cada cuadro hay un símbolo.",
        "En la parte inferior de cada cuadro hay un número del 1 al 9.",
        "Cada símbolo está emparejado con un número. Por ejemplo, la estrella está emparejada con el número 5.",
        "Estos cuadros tienen números en la parte inferior, pero el cuadro superior está vacío.",
        "Hará clic en los botones a continuación para seleccionar el símbolo correcto para emparejar con el número debajo del cuadro resaltado.",
        "Practiquemos con los números que se muestran en la pantalla.",
    ]

    const langPref = sessionStorage.getItem("preferredLanguage");
    const continueText = langPref !== "ES" ? "Tap here to continue" : "Toca aquí para continuar"
    const tutorialTexts = langPref !== "ES" ? tutorialTextsEnglish : tutorialTextsEspanol
    const okText = langPref !== "ES" ? "Okay" : "Bueno"
    const nextInstText = langPref !== "ES" ? "Tap for next instruction" : "Toque para ver las siguientes instrucciones"

    const tooltipProps = {
        'data-tip': 'tooltip',
        'data-event': 'show',
        'data-scroll-hide': 'false'
    }

    const [completed, setCompleted] = useState(false);
    const [correctCount, setCorrect] = useState(0); // number of correct attempted 
    const [attemptedCount, setAttempted] = useState(0); // number of attempted
    const [enteredList, setEntered] = useState([]); // list of entered symbols
    const [answerList, setAnswers] = useState([]); // list of correct answers

   


    let tutorialRefs = Array(5).fill(useRef(null));

    /**
     * There are 5 major points on the screen where the tooltips point to
     * 0 is the top row of the top table
     * 1 is the bottom row of the top table
     * 2 is the first cell in the first row of the bottom table
     * 3 is the bottom row, middle column
     * 5 is the first button, the circle one
     */
    const orderOfRefs = [1, 0, 1, 1, 3, 4, 2];
    const [currRef, setCurrRef] = useState(0);
    const [timerCompleted, setTimerCompleted] = useState(false);

    // shows the current tutorial tooltip
    React.useEffect(() => {
        if (props.demo && currRef < orderOfRefs.length)
            ReactTooltip.show(tutorialRefs[orderOfRefs[currRef]])
        
    });

    React.useEffect(() => {
        setCompleted(false);
    },[]);

    React.useEffect(() => {
       if(!props.demo && completed === true) {
           recordScore();
       }
    },[props.demo, completed]);


    React.useEffect(() => {
        // sets timer during the first load
        const timer = setTimeout(() => {
            setTimerCompleted(true);
        }, 2*1000);
        return () => clearTimeout(timer); 
    },[]);

    //sets a new timer
    function newTimer(){
        setTimeout(() => {
            setTimerCompleted(true);
        }, 2*1000);
    }

    //Resets the button to not visible 
    //for each instruction
    function resetTimer() {
        setTimerCompleted(false);
        newTimer();
    }

    function updateScore(correct, attempted, entered, answer) {
        setAttempted(attempted)
        setCorrect(correct)
        Correct(correctCount);
       
        let entered_number = symbols.indexOf(entered) + 1
        let answer_number = symbols.indexOf(answer) + 1 

        let newEntered = enteredList
        let newAnswers = answerList
        setEntered(newEntered.concat(entered_number))
        setAnswers(newAnswers.concat(answer_number))

    }

      function recordScore(){
       api.record_prompt_response(props.name, 
        {
            'attempted': attemptedCount, 
            'correct': correctCount, 
            'entered': enteredList, 
            'answers': answerList
        })
       

    }

    let referenceTable = 
        <table className="symbol-table" >
            <tr {...tooltipProps} ref={node => { tutorialRefs[0] = node; }}>
                {symbols.map((symbol) => {
                    return <td><i className={symbol}></i></td>
                })}
            </tr>
            <tr {...tooltipProps} ref={node => { tutorialRefs[1] = node; }}>
                {symbolValues.map((index) => {
                    return <td>{index}</td>
                })}
            </tr>
        </table>


    let normalGame = <div>
        {referenceTable}
        <br/><br/><br/><br/><br/><br/><br/>
        {props.demo || (!props.demo && props.started) ? <SymbolMatchingPlayerTable 
            refs={[(node) => {tutorialRefs[2] = node}, 
                    (node) => tutorialRefs[3] = node, 
                    (node) => tutorialRefs[4] = node]}
            demo={props.demo}
            tutorialOngoing={props.demo && currRef < orderOfRefs.length}
            updateScore = {updateScore}
            onCompletion={() => {
                setCompleted(true)
                if (!props.demo) {
                    props.onCompletion()
                }
            }}
        />: null}
        <br/><br/>

        {/* Sets next button based on demo state */}
        {completed ? <ButtonContainer 
            colors={[COLORS.blue]}  
            buttonTexts={[continueText]}
            buttonType='filled'
            onClick={props.onCompletion ? () => props.onCompletion() : null}
        /> : null}
    </div>

    // Creates tooltips and such for the demo
    let demoGame = <div>
        {/* Creates tooltip + next button*/}
        {currRef < orderOfRefs.length && !completed ? 
        <div> 
            <ReactTooltip 
                place="bottom" 
                effect="solid" 
                clickable={true} 
                multiline={true} 
                className="tooltip"
            >
                <p className="tutorial-text">{tutorialTexts[currRef]}</p>
            </ReactTooltip> 
        </div> : null}

        {normalGame}

        {currRef < orderOfRefs.length && !completed ? 
            <div style={{visibility: timerCompleted ? 'visible' : 'hidden'}}>
            <ButtonContainer 
                colors={[COLORS.blue]}  
                buttonTexts={currRef === orderOfRefs.length - 1 ?[okText] : [nextInstText]}
                buttonType='filled'
                onClick={() => {
                    setCurrRef(currRef + 1)
                    resetTimer();
                }}
            />
            </div>
         : null}

    </div>

    if (props.demo === true) {
        return(<div>{demoGame}</div>)
    } else {
        return(normalGame)
    }

};




